/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsersUserPermissions } from './usersUserPermissions';
import { UsersPageAccessPermissions } from './usersPageAccessPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UsersPermissions { 
    pageAccess: UsersPageAccessPermissions;
    user: UsersUserPermissions;
}
export const UsersPermissions_pageAccess_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPermissions_user_Validators: ValidatorFn[] =
    [  Validators.required, ];


